<template>
    <teleport to="body">
        <div v-if="show" class="backdrop" @click="tryClose"></div>
        <div v-if="show" class="nav_back" :style="{top:pos_top+'px'}">
            <div class="wrapper">

                <ul>
                    <li v-for="(menu, index) in menus" :key="index">
                        <navi-menu :menus="menu.subs" :type="menu.type" @close="tryClose"/>
                    </li>
                </ul>
            </div>
        </div>
    </teleport>
</template>
<script>
import NaviMenu from './Navmenu';
export default {
    props:{
        show: {
            type: Boolean,
            required: true,
        },
        pos_top:{
            type:Number,
            required:true
        }
    },
    components:{
        NaviMenu,
    },
    data(){
        return{
            menus:''
        }
    },
    created() {
        this.$store.dispatch("menu/fetchDocumentLists");
    },
    mounted() {
        this.menus = this.$store.state.menu.menus;
    },
    emits: ["close"],
    methods: {
        tryClose() {
            this.$emit("close");
        },
    },
}
</script>
<style lang="scss" scoped>
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10;
}
.nav_back{
    position:fixed;
    background:white;
    width:100%;
    height:450px;
    z-index:2000;
    box-shadow: 0 1px 7px #333;
    padding-top:20px;
    display:flex;
    justify-content: center;
    .wrapper{
        width:1300px;
        ul{
            display:flex;
            li:not(:last-child) {
                border-right: 1px solid #ebeef3;
            }
            li{
                width:14%;
            }
        }


    }
}
</style>
